<template>
  <vs-row style="height: 100%; position:relative;">
    <vs-col vs-w="12">
      <div class="vx-card form-card" ref="card">
        <div class="vx-card__header">
          <vs-col vs-type="flex" vs-justify="space-between" vs-align="center" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
            <h3>{{ [this.id ? 'MODIFICA' : 'NUOVO','PACCHETTO'].join(' ')}}</h3>
            <feather-icon icon="XIcon" @click="closeSidebar" class="cursor-pointer"></feather-icon>
          </vs-col>
        </div>
        <vs-divider />
        <div class="vx-card__body">
          <form v-on:submit.prevent="" data-vv-scope="pacchetto">
            <vs-row>
              <vs-col class="w-full px-2 mt-2">
                <label class="vs-input--label">Pacchetto</label>
                <vs-input v-model="nome" class="w-full" name="nome" placeholder="Inserisci il nome del pacchetto" v-validate="'required|alpha_spaces'" />
                <span class="text-danger text-sm"  v-show="errors.has('pacchetto.nome')">{{ errors.first('pacchetto.nome') }}</span>
              </vs-col>
              <vs-col class="w-full px-2 mt-2">
                <label class="vs-input--label">Servizio</label>
                <v-select name="servizio" class="w-full" placeholder="Scegli il servizio.." :options="servizi" v-model="servizio" v-validate="'required'"><span slot="no-options">Nessun risultato</span></v-select>
                <span class="text-danger text-sm"  v-show="errors.has('pacchetto.servizio')">{{ errors.first('pacchetto.servizio') }}</span>
              </vs-col>
              <vs-col class="w-full px-2 mt-2">
                <label class="vs-input--label">Tipo tariffa</label>
                <v-select name="tariffa" class="w-full" placeholder="Tariffa" label="nome" :options="tariffe" v-model="tariffa" v-validate="'required'"><span slot="no-options">Nessun risultato</span></v-select>
                <span class="text-danger text-sm"  v-show="errors.has('pacchetto.tariffa')">{{ errors.first('pacchetto.tariffa') }}</span>
              </vs-col>
              <vs-col class="w-full px-2 mt-2">
                <label class="vs-input--label">Lista tariffe scelte</label>
                <multiselect  v-model="selected_tariffa_servizi"
                              :options="tariffa_servizi"
                              :multiple="true"
                              :close-on-select="false"
                              :clear-on-select="false"
                              :preserve-search="true"
                              selectLabel="Invio per selezionare"
                              deselectLabel="Invio per de-selezionare"
                              selectedLabel="Selezionato"
                              noOptions="Lista vuota"
                              placeholder="Selezionare.."
                              label="label"
                              track-by="id"
                              :preselect-first="true">
                  <template slot="selection"
                            slot-scope="{ values, search, isOpen }">
                            <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} opzioni selezionate</span>
                  </template>
                  <template slot="noOptions">Lista vuota</template>
                  <template slot="tag" slot-scope="option">
                    {{option.length}}
                  </template>
                </multiselect>
              </vs-col>
            </vs-row>
          </form>
        </div>
        <div class="vx-card__footer">
          <vs-row vs-type="flex" vs-justify="space-around">
            <vs-button v-if="this.id" :disabled="!$acl.check('responsabile') && this.utente_id != this.creatore.id" @click="eliminaPacchetto($event)" icon-pack="feather" icon="icon-trash" color="danger" type="line" align="right">Elimina</vs-button>
            <vs-button @click="salvaPacchetto($event)" type="line" color="success" icon-pack="feather" icon="icon-save">Salva</vs-button>
          </vs-row>
        </div>
      </div>
    </vs-col>
  </vs-row>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import axios from 'axios'
import vSelect from 'vue-select'
import Multiselect from 'vue-multiselect'

// For custom error message
import { Validator } from 'vee-validate';

const dict = {
  custom: {
    nome: {
      required: 'Nome è un campo obbligatorio',
      alpha_spaces: 'Sono ammessi solo caratteri alfabetici e spazi'
    },
    tariffa: {
      required: 'Tariffa è un campo obbligatorio',
    },
    servizio: {
      required: 'Servizio è un campo obbligatorio',
    },
  }
};

// register custom messages
Validator.localize('it', dict);

export default {
  data() {
    return {
      // Pacchetto
      id: null,
      nome: "",

      tariffa: null,
      tariffe: [],
      servizio: null,
      servizi: [],

      selected_tariffa_servizi: [],
      tariffa_servizi: [],
    }
  },
  props: {
    selected: Object
  },
  components: {
    vSelect,
    Multiselect,
  },
  mounted() {
    this.populateServizi()
    this.populateTariffe()
    this.getTariffeServiziComplete()
    if(this.selected) {
      Object.keys(this.selected).forEach(e => this[e] = !this.selected[e] ? "" : this.selected[e])
      if(this.selected.servizio) {
        this.servizio['label'] = this.servizio.codice
      }
      if(this.selected.tariffa_servizi) {
        this.selected_tariffa_servizi = this.selected.tariffa_servizi.map( e => ({ label: [e.tariffa_servizio.nome,e.tariffa_servizio.tipo_servizio].join(' - '), id: e.tariffa_servizio.id }))
      }
    }
  },
  methods: {
    populateTariffe() {
      axios.get(process.env.VUE_APP_BACKEND_API+'/tariffa_servizio/trova_tariffe', {
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true,
      })
      .then( res => {
        this.tariffe = res.data
      })
    },
    populateServizi() {
      axios.get(process.env.VUE_APP_BACKEND_API+'/tariffa_servizio/trova_servizi_crm', {
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true,
      })
      .then( res => {
        res.data.forEach(e => {
          e['label'] = e['codice']
          this.servizi.push(e)
        })
      })
    },
    getTariffeServizi() {
      axios.post(process.env.VUE_APP_BACKEND_API+'/tariffa_servizio/trova_tutti', {id_servizio: this.servizio['id'], id_tariffa: this.tariffa['id']},
                {headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                withCredentials: true,
      }).then(response => (
        this.tariffa_servizi = response.data.map(e => {
                                  e['label'] = `${e['nome']}`+' - '+`${e['tipo_servizio']}`+`${e['tipo_servizio']}`
                                  return e
                                })))
      .catch(e => console.log(e))
    },
    getTariffeServiziComplete() {
      axios.get(process.env.VUE_APP_BACKEND_API+'/tariffa_servizio/trova_proprio_tutti',
                {headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                withCredentials: true,
      }).then(response => (
        this.tariffa_servizi = response.data.map(e => {
                                  e['label'] = `${e['nome']}`+' - '+`${e['servizio']['codice']}`+' - '+`${e['tipo_servizio']}`
                                  return e
                                })))
      .catch(e => console.log(e))
    },

    buildSaveObject() {
      let obj = {
        nome: this.nome.charAt(0).toUpperCase() + this.nome.slice(1),
        id_servizio: this.servizio.id,
        id_tariffa: this.tariffa.id,
        tariffa_servizi: this.selected_tariffa_servizi.map( e => e.id )
      }
      if(this.id) {
        obj['id'] = this.id
      }
      return obj
    },

    salvaPacchetto(ev) {
      this.validatePacchetto().then(() => {
        let action = this.id ? 'modifica' : 'crea'
        axios.post(process.env.VUE_APP_BACKEND_API+'/tariffa_servizio/' + action + '_pacchetto', this.buildSaveObject(), {
          headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
          withCredentials: true,
        })
        .then(() => {
          this.$emit('pacchetto-salvato')
          ev.stopPropagation()
        })
        .catch(e => console.log(e))
      })
    },

    validatePacchetto() {
      console.log('VALIDATE PACCHETTO');
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('pacchetto').then(result => {
          if (result) {
            console.log('success');
            resolve(true)
          } else {
            console.log('failed');
            reject("correct all values");
          }
        })
      })
    },
    eliminaPacchetto(ev) {
      this.$emit('elimina-pacchetto')
      ev.stopPropagation()
    },
    closeSidebar(ev) {
      this.$emit('close-me')
      ev.stopPropagation()
    },
  },
  watch: {
    servizio () {
      if (this.tariffa.id) {
        this.getTariffeServizi()
      }
    },
    tariffa () {
      if (this.servizio.id) {
        this.getTariffeServizi()
      }
    },
  },
}
</script>
